import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.InvestmentSearchRoot),
  () => import('./InvestmentSearch'),
  (InvestmentSearch) => {
    ComponentUtil.binder(Hooks.InvestmentSearchRoot, InvestmentSearch);
  },
);
